import styled from 'styled-components'

export const THeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  grid-gap: 8px;
  
  & div:nth-child(1) {
    text-align: left;
  }
`